import { required } from '@vuelidate/validators'

export const DoDriverSearchValidation = {
    iin: { required },
}
